<template>
  <div class="BIDTables">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12 md8>
          <v-card v-if="loadRPH">
            <v-card-title class="title">
              Reporte Personas por Hogar
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRPH === null">
                  <download-csv
                    :data="dataValsRPH"
                    :name="'Reporte Personas por Hogar.csv'"
                    :labels="labelsRPH"
                    :fields="fieldsRPH"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRPH"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersRPH"
                :dataVals="dataValsRPH"
                :searchActive="true"
                :key="tableKeyRPH"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md8>
          <v-card v-if="loadRNVRU">
            <v-card-title class="title">
              Reporte Nivel Educativo vs Zona Residencial
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRNVRU === null">
                  <download-csv
                    :data="dataValsRNVRU"
                    :name="'Reporte Nivel Educativo vs Zona Residencial.csv'"
                    :labels="labelsRNVRU"
                    :fields="fieldsRNVRU"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRNVRU"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersRNVRU"
                :dataVals="dataValsRNVRU"
                :searchActive="false"
                :key="tableKeyRNVRU"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md8>
          <v-card v-if="loadRAP">
            <v-card-title class="title">
              Reporte Abandono en Preguntas
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRAP === null">
                  <download-csv
                    :data="dataValsRAP"
                    :name="'Reporte Abandono en Preguntas.csv'"
                    :labels="labelsRAP"
                    :fields="fieldsRAP"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingRAP"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersRAP"
                :dataVals="dataValsRAP"
                :searchActive="false"
                :key="tableKeyRAP"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card v-if="loadGEO">
            <v-card-title class="title">
              Reporte de Geolocalización
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsGEO === null">
                  <download-csv
                    :data="dataValsGEO"
                    :name="'Reporte de Geolocalización.csv'"
                    :labels="labelsGEO"
                    :fields="fieldsGEO"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingGEO"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <table-base
                :headers="headersGEO"
                :dataVals="dataValsGEO"
                :searchActive="false"
                :key="tableKeyGEO"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md10>
          <v-card v-if="loadMuestra">
            <v-card-title class="title">
              Cobertura de Muestra
              <v-spacer/>
              <v-card-actions v-if="dataValsMuestra.length > 0">
                <v-btn color="info" :disabled="dataValsMuestra.length < 1">
                  <download-csv
                    :data="dataValsMuestra"
                    :name="'Cobertura de Muestra.csv'"
                    :labels="labelsMuestra"
                    :fields="fieldsMuestra"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingMuestra"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-if="dataValsMuestra.length > 0">
              <data-table
                :headers="headersMuestra"
                :dataVals="dataValsMuestra"
                :searchActive="true"
                :key="tableKeyMuestra"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md10>
          <v-card v-if="loadCober">
            <v-card-title class="title">
              Cobertura de Muestra por Encuestador
              <v-spacer/>
              <v-card-actions v-if="dataValsCober.length > 0">
                <v-btn color="info" :disabled="dataValsCober.length < 1">
                  <download-csv
                    :data="dataValsCober"
                    :name="'Cobertura de Muestra por Encuestador.csv'"
                    :labels="labelsCober"
                    :fields="fieldsCober"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingCober"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-if="dataValsCober.length > 0">
              <data-table
                :headers="headersCober"
                :dataVals="dataValsCober"
                :searchActive="true"
                :key="tableKeyCober"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 lg10>
          <v-card v-if="loadReports"
            class="px-3"
          >
            <v-card-title class="title">
              Reportes Guardados
            </v-card-title>

            <v-layout wrap align-start justify-center row fill-height>
              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menuIniReports"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Fecha Inicial"
                    v-model="dateIniReports"
                    prepend-icon="event"
                    readonly
                    hint="Debe ser anterior a la fecha final"
                    persistent-hint
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateIniReports"
                    locale="es-CO"
                    no-title
                    scrollable
                    actions
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-spacer/>

              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menuEndReports"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Fecha Final"
                    v-model="dateEndReports"
                    prepend-icon="event"
                    readonly
                    hint="Debe ser posterior a la fecha inicial"
                    persistent-hint
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateEndReports"
                    locale="es-CO"
                    no-title
                    scrollable
                    actions
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-spacer/>

              <v-flex xs12>
                <v-autocomplete
                  :items="savedReports"
                  label="Reportes"
                  v-model="selectedReport"
                  :disabled="loadingReports"
                  color="secondary"
                  item-text="nombre"
                  return-object
                  hide-no-data
                  no-data-text="No se tienen Reportes Guardados."
                ></v-autocomplete>
              </v-flex>

              <v-card-text
                v-if="loadingReports"
                class="text-xs-center"
              >
                <v-progress-circular
                  class="text-xs-center"
                  :size="progressSize"
                  :width="progressWidth"
                  color="info"
                  indeterminate
                ></v-progress-circular>
              </v-card-text>

              <report-multiple v-else-if="selectedReport"
                :data="dataReports"
                :csvname="csvnameReports"
                :questionsShow="selectedReport.data.questions"
              />
            </v-layout>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableWithTotals'
import tableBase from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'
import reportMultiple from '@/components/Multiple'

export default {
  name: 'BIDTables',

  components: {
    'data-table': dataTable,
    'table-base': tableBase,
    'download-csv': JsonCSV,
    'report-multiple': reportMultiple
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/bid/tbl/',
        pathMuestra: '/charts/muestra/',
        pathReports: '/formularios/reporte/',
        pathGetReports: '/formularios/savereporte/',
        page: 1
      },

      operativo: null,
      progressSize: 70,
      progressWidth: 7,

      headersMuestra: [],
      dataValsMuestra: [],
      labelsMuestra: {},
      fieldsMuestra: [],
      tableKeyMuestra: 0,
      loadingMuestra: false,
      loadMuestra: false,

      loadingRPH: false,
      loadingRNVRU: false,
      loadingRAP: false,

      headersRPH: [
        {
          text: 'Manzana',
          align: 'left',
          value: 'mnz',
          str: 'Totales'
        },
        { text: 'Total personas en la manzana', value: 'no_personas' },
        { text: 'Total Encuestas', value: 'total' }
      ],
      labelsRPH: {
        mnz: 'Manzana',
        no_personas: 'Total personas en la manzana',
        total: 'Total Encuestas'
      },
      fieldsRPH: ['mnz', 'no_personas', 'total'],
      dataValsRPH: null,
      loadRPH: false,
      tableKeyRPH: 0,

      headersRNVRU: [
        {
          text: 'Nivel Educativo',
          align: 'left',
          value: 'nv_educativo',
          str: 'Totales'
        },
        { text: 'Total urbano', value: 'Urbano' },
        { text: 'Total rural', value: 'Rural' }
      ],
      labelsRNVRU: {
        nv_educativo: 'Nivel Educativo',
        Urbano: 'Total urbano',
        Rural: 'Total rural'
      },
      fieldsRNVRU: ['nv_educativo', 'Urbano', 'Rural'],
      dataValsRNVRU: null,
      loadRNVRU: false,
      tableKeyRNVRU: 0,

      headersRAP: [
        {
          text: 'Pregunta',
          align: 'left',
          value: 'pregunta',
          str: 'Totales'
        },
        { text: 'Total Abandonos', value: 'total' }
      ],
      labelsRAP: {
        pregunta: 'Pregunta',
        total: 'Total Abandonos'
      },
      fieldsRAP: ['pregunta', 'total'],
      dataValsRAP: null,
      loadRAP: false,
      tableKeyRAP: 0,

      headersGEO: [
        {
          text: 'Encuesta',
          align: 'left',
          value: 'encuesta'
        },
        { text: 'Encuestado', value: 'encuestado' },
        { text: 'Inicio', value: 'inicio' },
        { text: 'Fin', value: 'fin' },
        { text: 'Latitud', value: 'latitud' },
        { text: 'Longitud', value: 'longitud' }
      ],
      labelsGEO: {
        encuesta: 'Encuesta',
        encuestado: 'Encuestado',
        inicio: 'inicio',
        fin: 'fin',
        latitud: 'Latitud',
        longitud: 'Longitud'
      },
      fieldsGEO: ['encuesta', 'encuestado', 'inicio', 'fin', 'latitud', 'longitud'],
      dataValsGEO: null,
      loadGEO: false,
      tableKeyGEO: 0,

      headersCober: [
        {
          text: 'Encuestador',
          align: 'left',
          value: 'encuestador'
        },
        { text: 'Municipio', value: 'municipio' },
        { text: 'Zona', value: 'zona' },
        { text: 'Manzana', value: 'manzana' },
        { text: 'Encuestas', value: 'encuestas' },
        { text: 'Porcentaje', value: 'porcentaje' }
      ],
      labelsCober: {
        encuestador: 'Encuestador',
        municipio: 'Municipio',
        zona: 'Zona',
        manzana: 'Manzana',
        encuestas: 'Encuestas',
        porcentaje: 'Porcentaje'
      },
      fieldsCober: ['encuestador', 'municipio', 'zona', 'manzana', 'encuestas', 'porcentaje'],
      dataValsCober: null,
      loadCober: false,
      tableKeyCober: 0,

      // Reporte Multiple
      loadReports: false,
      loadingReports: false,
      selectedReport: null,
      savedReports: [],

      dateIniReports: null,
      dateEndReports: null,

      dataReports: [],
      csvnameReports: ' '
    }
  },

  watch: {
    operativo: function () {
      this.changeData()
    },

    selectedReport: function () {
      this.reply()
    }
  },

  computed: {
    /**
     * Determina la tabla Reporte Abandono en Preguntas a cargar
     * @return {String} abnd: si es operativo minera; abndg: si el operativo es de gobernanza
     */
    'tableRAP': function tableRAP () {
      let projects = [4, 27] // lista de operativos
      if (projects.includes(this.operativo)) {
        return 'abnd'
      }
      return 'abndg'
    },

    /**
     * Determina la tabla de geolocalización
     * @return {String} Mgeo: si es operativo minera; Ggeo: si el operativo es de gobernanza
     */
    'tableGEO': function tableGEO () {
      let projects = [4] // lista de operativos
      if (projects.includes(this.operativo)) {
        return 'Mgeo'
      }
      return 'Ggeo'
    },

    /**
     * Determina el valor del breakpoint para renderizar elementos a conveniencia
     * @return {boolean} Truo o Flase segun el elemento
     */
    breakpoint () {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg': return false
        case 'xl': return false
        default: return true
      }
    }
  },

  methods: {
    /**
     *  Carga la tabla de Reporte Personas por Hogar
     */
    loadTableRPH () {
      this.loadingRPH = true
      this.dataValsRPH = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          tablas: 'PxPH',
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRPH = resp.data
          t.loadingRPH = false
          t.tableKeyRPH += 1
        })
        .catch(function (err) {
          t.dataValsRPH = []
          t.loadingRPH = false
          t.tableKeyRPH += 1
          console.error(err)
        })
    },

    /**
     *  Carga la tabla de Reporte Aplicacion por Versión
     */
    loadTableRNVRU () {
      this.loadingRNVRU = true
      this.dataValsRNVRU = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          tablas: 'NVxRU',
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRNVRU = resp.data
          t.loadingRNVRU = false
          t.tableKeyRNVRU += 1
        })
        .catch(function (err) {
          t.dataValsRNVRU = []
          t.loadingRNVRU = false
          t.tableKeyRNVRU += 1
          console.error(err)
        })
    },

    /**
     *  Carga la tabla de Reporte Pregunta Abandono
     */
    loadTableRAP () {
      this.loadingRAP = true
      this.dataValsRAP = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          tablas: this.tableRAP,
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRAP = resp.data
          t.loadingRAP = false
          t.tableKeyRAP += 1
        })
        .catch(function (err) {
          t.dataValsRAP = []
          t.loadingRAP = false
          t.tableKeyRAP += 1
          console.error(err)
        })
    },

    /**
     *  Carga la tabla de Reporte Geolocalización
     */
    loadTableGEO () {
      this.loadingGEO = true
      this.dataValsGEO = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        operativo: this.operativo,
        params: {
          tablas: this.tableGEO,
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsGEO = resp.data
          t.loadingGEO = false
          t.tableKeyGEO += 1
        })
        .catch(function (err) {
          t.dataValsGEO = []
          t.loadingGEO = false
          t.tableKeyGEO += 1
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla cobertura agregando los datos faltantes de la tabla
     */
    processMuestra () {
      this.loadingMuestra = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathMuestra
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])
          vals.splice(vals.length - 2)
          let totMeta = 0
          let totCont = 0

          // calcualr el porcentaje y formatea los datos
          resp.data.forEach(function (element) {
            totMeta += element.meta
            totCont += element.conteo

            let perc = element.conteo / element.meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              meta: element.meta,
              conteo: element.conteo,
              porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            vals.forEach(function (key) {
              obj[key] = element[key]
            })

            t.dataValsMuestra.push(obj)
          })

          let ponder = totCont / totMeta * 100
          t.tableConfig(vals, Number.parseFloat(ponder).toFixed(1))

          t.tableKeyMuestra += 1
          t.loadingMuestra = false
        })
        .catch(function (err) {
          t.dataValsMuestra = []
          t.loadingMuestra = false
          console.error(err)
        })
    },

    /**
     * Confogura valores necesarios para el funcioanimiento de la tabla,
     * headers, labels y fields
     * @param  {array}   values Lista de valores a agregar
     * @param  {integer} ponder Valor ponderado, para adjuntar a la tabla
     */
    tableConfig (values, ponder) {
      console.log(values)

      let head = []

      values.forEach(function (key) {
        let obj = {
          text: key,
          align: 'left',
          value: key,
          str: ' '
        }
        head.push(obj)
      })

      head[head.length - 1].str = 'Totales'

      this.headersMuestra = head.concat([
        { text: 'Muestra', value: 'meta', align: 'right' },
        { text: 'Conteo', value: 'conteo', align: 'right' },
        { text: 'Avance %', value: 'porcentaje', align: 'right', str: ponder }
      ])

      // Agrega los Labels para el CSV
      let obj = {}

      values.forEach(function (key) {
        obj[key] = key
      })

      this.labelsMuestra = Object.assign(obj, {
        meta: 'Muestra',
        conteo: 'Conteo',
        porcentaje: 'Avance'
      })

      // Agrega los Fields para el CSV
      this.fieldsMuestra = values.concat(['meta', 'conteo', 'porcentaje'])
    },

    /**
     *  Carga la tabla de Reporte Cobertura Muestra por Encuestador
     */
    loadTableCober () {
      this.loadingCober = true
      this.dataValsCober = null

      let request = {
        method: 'get',
        url: this.backConf.path,
        operativo: this.operativo,
        params: {
          tablas: this.tableCober,
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsCober = resp.data
          t.loadingCober = false
          t.tableKeyCober += 1
        })
        .catch(function (err) {
          t.dataValsCober = []
          t.loadingCober = false
          t.tableKeyCober += 1
          console.error(err)
        })
    },

    // para reporte multiple
    /**
     * Obtiene la lista de reportes guardados
     */
    getSavedReports () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathGetReports
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.savedReports = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.savedReports = null
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Obtiene las respuestas de la pregunta solicitada
     */
    reply () {
      this.loadingReports = true

      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          data: this.selectedReport.data.query,
          fecha_i: this.dateIniReports,
          fecha_f: this.dateEndReports
        },
        url: this.backConf.pathReports
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataReports = resp.data
          t.csvnameReports = t.selectedReport.nombre
          t.loadingReports = false
        })
        .catch(function (err) {
          t.dataReports = []
          t.loadingReports = false
          console.error(err)
        })
    },

    /**
     * Cambia la lista de preguntas segun el operativo
     */
    changeData () {
      if (this.operativo === 4) { // BID Minera Piloto
        this.loadRPH = true
        this.loadTableRPH()
        this.loadRNVRU = true
        this.loadTableRNVRU()
        this.loadRAP = true
        this.loadTableRAP()
      } else if (this.operativo === 9) { // BID Gobernanza Piloto
        this.loadRAP = true
        this.loadTableRAP()
        this.loadGEO = true
        this.loadTableGEO()
      } else if (this.operativo === 23) { // BID Gobernanza Producción
        this.loadRAP = true
        this.loadTableRAP()
        this.loadGEO = true
        this.loadTableGEO()
        this.loadMuestra = true
        this.processMuestra()
      } else if (this.operativo === 27) { // BID Minera Producción
        this.loadRAP = true
        this.loadTableRAP()
        // this.loadCober = true
        // this.loadTableCober()
        this.loadReports = true
        this.getSavedReports()
      }
    }
  }
}
</script>
